// Presentational bits shared by the group detail panels (GroupDetail and the
// Documents panel it delegates to).
import React from 'react'
import { Box, Grid } from '@mui/material'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import { groupStatusLabel, groupStatusTone } from '../../lib/groupStatus'

export const detailCard = {
  background: '#FFFFFF',
  border: '1px solid #D9D9D9',
  boxShadow: '0px 8px 24px rgba(149, 157, 165, 0.2)',
  borderRadius: '4px',
  padding: '20px',
  marginBottom: '20px'
}

export const labelStyle = {
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '16px',
  letterSpacing: '0.005em',
  color: '#A9A9A9',
  margin: 0
}

export const valueStyle = {
  fontFamily: 'Lato',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '20px',
  letterSpacing: '0.001em',
  color: '#000000',
  margin: 0
}

export const sectionTitleStyle = {
  fontFamily: 'Lato',
  fontWeight: 600,
  fontSize: '14px',
  color: '#000000',
  margin: 0
}

export const rowStyle = {
  background: '#F8FAFC',
  borderRadius: '8px'
}

export const linkStyle = {
  fontSize: '13px',
  color: '#032A37',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  textDecoration: 'none',
  fontWeight: 600
}

export function titleCase(value) {
  if (!value || typeof value !== 'string') {
    return value
  }
  return value.replace(/_/g, ' ').replace(/\b\w/g, function(c) {
    return c.toUpperCase()
  })
}

export function safeText(value) {
  if (value === null || value === undefined || value === '') {
    return '—'
  }
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No'
  }
  if (typeof value === 'object') {
    return JSON.stringify(value)
  }
  return value
}

export function StatusPill(props) {
  const tone = groupStatusTone(props.status)
  let bg = '#DAE3E7'
  let color = '#8D8D8C'
  if (tone === 'positive') {
    bg = '#CCFFDD'
    color = '#0A7D3A'
  } else if (tone === 'negative') {
    bg = '#FDE2E2'
    color = '#8F191C'
  }
  return (
    <span
      style={{
        background: bg,
        color,
        borderRadius: '10px',
        padding: '3px 12px',
        fontSize: '11px',
        fontFamily: 'Open Sans',
        fontWeight: 600,
        display: 'inline-block',
        whiteSpace: 'nowrap'
      }}
    >
      {groupStatusLabel(props.status)}
    </span>
  )
}

export function Field(props) {
  return (
    <Grid item xs={12} sm={props.sm || 4} md={props.md || 4}>
      <p style={labelStyle}>{props.label}</p>
      <h6 style={valueStyle}>{safeText(props.value)}</h6>
    </Grid>
  )
}

export function CardHeader(props) {
  return (
    <div>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center" gap={1.5}>
          <div
            style={{
              width: '30px',
              height: '30px',
              background: '#032A37',
              borderRadius: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <GroupsOutlinedIcon
              style={{ color: '#ffffff', fontSize: '16px' }}
            />
          </div>
          <h6 style={sectionTitleStyle}>{props.title}</h6>
        </Box>
        <Box display="flex" alignItems="center" gap={1.5}>
          {props.status && <StatusPill status={props.status} />}
          {props.action}
        </Box>
      </Box>
      <div
        style={{
          borderBottom: '1px solid #D9D9D9',
          width: '100%',
          margin: '16px 0'
        }}
      />
    </div>
  )
}
